import AnalyticsWebClient, { envType, originType } from '@atlassiansox/analytics-web-client';
import { payloadPublisher, ExperiencePerformanceTypes } from '@atlassian/ufo';
import { ANALYTICS_PRODUCT_DEFAULT, ANALYTICS_SUBPRODUCT_ADV_CENTRAL, getEnvType } from '@atlassian/temp-analytics';
import { getEnvironment } from '@atlassian/temp-shared/environment';

/**
 * setting up publisher to transport whenever an experience is recorded across any page
 */
export const initUFO = () => {
  const apiHost =
    getEnvironment() === envType.PROD
      ? 'api-private.atlassian.com/gasv3/api/v1'
      : 'api-private.stg.atlassian.com/gasv3/api/v1';
  if (getEnvType() === envType.LOCAL) {
    return;
  }

  const analyticsClient = new AnalyticsWebClient(
    {
      env: getEnvType(),
      origin: originType.WEB,
      product: ANALYTICS_PRODUCT_DEFAULT,
      subproduct: ANALYTICS_SUBPRODUCT_ADV_CENTRAL,
    },
    { apiHost }
  );

  // TODO: COMMIT-7497 Find org and workspace ID
  // analyticsClient.setOrgInfo('dummy-fc0877ef-3ffd-4a22-81b9-68b6884e6a96');
  // analyticsClient.setWorkspaceInfo('workspaceAri / workspaceID');

  payloadPublisher.setup({
    gasv3: analyticsClient,
    product: ANALYTICS_PRODUCT_DEFAULT,
    app: {
      version: { web: '0.1.0' },
    },
    performanceConfig: {
      histogram: {
        [ExperiencePerformanceTypes.PageLoad]: {
          initial: {
            fmp: '2500_3000_3500_4000_5000_6000',
            tti: '4000_4500_5000_6000_7000_8000_9000',
          },
          transition: {
            fmp: '2500_3000_3500_4000_5000_6000',
            tti: '2500_3000_3500_4000_5000_6000',
          },
        },
        [ExperiencePerformanceTypes.PageSegmentLoad]: {
          initial: {
            fmp: '1000_2000',
            tti: '1000_2000',
          },
          transition: {
            fmp: '1000_2000',
            tti: '1000_2000',
          },
        },
        [ExperiencePerformanceTypes.InlineResult]: {
          result: '1000_2000',
          response: '1000_2000',
        },
        [ExperiencePerformanceTypes.Custom]: {
          duration: '1000_2000',
        },
      },
    },
  });
};
